import {Theme} from '@lookiero/aurora';
import StyleSheet from 'react-native-extended-stylesheet';

const {
  colorBgPrimary,
  colorBgPrimaryMediumLight,
  colorBgBase,
  space4,
  space1,
  space2,
  space025,
  borderWidth2,
  borderStyle,
} = Theme.get();

const indicatorSize = space4 + space1 + space1;

const enabledColor = colorBgPrimary;
const disabledColor = colorBgPrimaryMediumLight;

export const style = StyleSheet.create({
  stepIndicatorOutline: {
    backgroundColor: colorBgBase,
    width: indicatorSize,
    height: indicatorSize,
    padding: space025,
    borderRadius: indicatorSize,
    marginTop: space2 + space1,
  },
  stepIndicator: {
    borderWidth: borderWidth2,
    borderStyle: borderStyle,
    borderRadius: indicatorSize,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  stepIndicator_checked: {
    borderColor: enabledColor,
    backgroundColor: enabledColor,
  },
  stepIndicator_default: {
    borderColor: enabledColor,
  },
  stepIndicator_disabled: {
    borderColor: disabledColor,
  },
});
